var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"room-bottom"},[_c('goods',{staticClass:"goods",on:{"showgoods":_vm.showgoods}}),_c('message',{staticClass:"message",attrs:{"isTimReady":_vm.isTimReady},on:{"send-message":_vm.sendMessage}}),_c('gift',{staticClass:"gift",on:{"showGift":_vm.showGift}}),_c('like',{staticClass:"like",on:{"like":_vm.like}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }